export default {
  key: 'AIzaSyCOIyplEfezocWdL9z3IGVsjk6L048RTpI',
  version: 'quarterly',
};
